<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">微思翻译机构中心管理系统</div>
      <div class="login-form">
        <el-form ref="formInline" :model="formInline" :rules="ruleInline">
          <el-form-item prop="user">
            <el-input type="text" clearable size="large" v-model="formInline.user" placeholder="账号"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" clearable size="large" v-model="formInline.password" placeholder="密码">
            </el-input>
          </el-form-item>
          <el-form-item prop="validate">
            <el-input type="text" clearable size="large" v-model="formInline.validate" placeholder="验证码"
                      style="width: 200px;">
            </el-input>
            <img style="float: right;width: 170px;height: 38px" :src="qrcodeUrl" alt="验证码加载失败..."
                 @click="getValicode"/>
          </el-form-item>
          <el-form-item>
            <div style="color: #F56C6C;font-size: 14px;display: contents;">{{messages}}</div>
            <el-button style=" float: right;" type="primary" @click="handleSubmit('formInline')">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "Login",
    data() {
      return {
        messages: '',
        qrcodeUrl: "data:image/gif;base64,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",
        formInline: {
          user: '',
          password: '',
          validate: ''
        },
        ruleInline: {
          user: [
            {required: true, message: '请输入用户名', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'}
          ],
          validate: [
            {required: true, message: '请输入验证码', trigger: 'blur'}
          ]
        }
      }
    },
    created() {
      this.getValicode();
    },
    methods: {
      handleSubmit(name) {
        const that = this;
        this.$refs[name].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.$http.post('/api/login', {
            username: that.formInline.user,
            password: that.formInline.password,
            code: that.formInline.validate
          }).then(function (response) {
            if (response.data) {
              that.$message.success("登录成功");
              that.$router.push("/info");
              return
            }
            that.$message({
              type: 'info',
              message: '用户名或密码不正确!'
            });
            that.getValicode();
          }).catch(function (error) {
            that.$message({
              type: 'info',
              message: '用户名或密码不正确!'
            });
            that.getValicode();
          });
        })
      },
      getValicode() {
        const that = this;
        that.qrcodeUrl ='/api/getValicode?'+new Date();
      },
    }
  }
</script>

<style scoped>
  .login-container {
    width: 100%;
    min-height: 200px;
    background: url("../assets/JG-tbg.jpg") no-repeat;
  }
  .login-box {
    background-color: white;
    width: 500px;
    height: 350px;
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translate(-50%, -50%);
    border-radius: 1%;
    box-shadow: 2px 2px 10px #909090;
  }
  .login-header {
    text-align: center;
    font-size: 28px;
    font-weight: 800;
    margin-top: 15px;
  }

 .login-form {
    margin: 35px 60px 0 60px;
  }

</style>
